import React from 'react';
import {renewTokenKyc} from '../../lib/api/index';

const idenfyUrl = 'https://ui.idenfy.com';

function Idenfy({data, inProgress, setBtnDisabled, setIframeMethodType, uuid}) {
  const [eventListener, setEventListener] = React.useState(false);
  const [authToken, setAuthToken] = React.useState(
    data?.credit_request_session?.idenfy_sessions[0]?.tokens[0]?.token,
  );
  const timeoutsRef = React.useRef([]);

  const renewToken = React.useCallback(async () => {
    const dataToken = await renewTokenKyc(uuid);
    setAuthToken(dataToken.data.data);
  }, [uuid]);

  React.useEffect(() => {
    if (!eventListener && !inProgress) {
      window.addEventListener('message', event => {
        idenfyListener(
          event,
          setBtnDisabled,
          setIframeMethodType,
          renewToken,
          timeoutsRef,
        );
      });

      setEventListener(true);
    }

    return () => {
      window.removeEventListener('message', event => {
        idenfyListener(event, setBtnDisabled, setIframeMethodType);
      });
      // Clear all pending timeouts on component unmount
      timeoutsRef.current.forEach(timeout => clearTimeout(timeout));
      timeoutsRef.current = [];
    };
  }, [
    inProgress,
    eventListener,
    setBtnDisabled,
    setIframeMethodType,
    renewToken,
  ]);

  const iframe = `
    <iframe 
      src="${idenfyUrl}/?authToken=${authToken}&lang=ro"
      lang="ro"
      allowfullscreen
      width="100%" height="100%" style="position: absolute; top: 0; left: 0;"
      allow="camera *;encrypted-media *;"
      id="kyc-idenfy"
    />
  `;

  return (
    <div
      dangerouslySetInnerHTML={{__html: iframe}}
      className="relative overflow-hidden w-full"
      style={{height: '640px'}}
    />
  );
}

function idenfyListener(
  event,
  setBtnDisabled,
  setIframeMethodType,
  renewToken,
  timeoutsRef,
) {
  if (event.origin !== idenfyUrl) {
    return;
  }

  console.log('idenfyUrl =====', event.data);

  const {status, manualStatus} = event.data;

  if ([status, manualStatus].includes('waiting')) {
    return;
  }

  if (manualStatus === 'approved') {
    const timeoutId = setTimeout(() => {
      setIframeMethodType('Idenfy');
      setBtnDisabled(false);
    }, 5 * 1000);

    timeoutsRef.current.push(timeoutId);
    return;
  }

  const timeoutId = setTimeout(renewToken, 5 * 1000);
  timeoutsRef.current.push(timeoutId);
}

export default Idenfy;
